import { styled } from 'styled-components';
export const StepWrapper = styled.div `
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  position: relative;
  flex-shrink: 0;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
export const StepUnderline = styled.div `
  background: ${({ theme, $getColor }) => $getColor({ theme })};
  bottom: 0;
  position: absolute;
  width: 100%;
  height: 4px;
  border-radius: 2px;
`;
export const StepLabelWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  ${({ theme }) => theme.typography.textMedium}

  color: ${({ theme, $getLabelColor }) => $getLabelColor({ theme, hover: false })};
  ${StepWrapper}:hover {
    color: ${({ theme, $getLabelColor }) => $getLabelColor({ theme, hover: true })};
  }
`;
export const Counter = styled.span `
  ${({ theme }) => theme.typography.textSmall}
  ${({ theme }) => theme.typography.weightMedium}
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.grey00_1};
  height: 16px;
  width: 16px;
  background-color: ${({ theme, $getColor }) => $getColor({ theme })};
  border-radius: 50%;
  flex-shrink: 0;
`;
export const StepsGroupWrapper = styled.div `
  display: inline-flex;
  align-items: center;
  gap: 16px;
  padding: 0 12px;
  overflow: auto;
`;
